import { IBaseAction } from "../Actions/BaseAction";
import { PolygonType } from "../Models/Maps/Enums/PolygonType";
import { IPolygon } from "../Models/Maps/IPolygon";
import { ISubmitMobilyticsJobRequest } from "../../../Models/Requests/ISubmitMobilyticsJobRequest";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { IMobilyticsScenarioFormState } from "../Pages/Apps/Mobilytics/SubmitMobilyticsLogic";
import { IPointBase } from "../../../Models/IPoint";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";

export type SearchedPlaceInfo = {
    name: string;
    placeId: string;
    lat: number;
    lng: number;
    address: string;
    points?: [];
};

export type ISafegraphLocationRequest = {
    latitude: number;
    longitude: number;
    brandName: string;
    address: string;
    zipcode: string;
}

export type INearestLocationsSafegraphRequest = {
    ids: number[];
    latitude: number;
    longitude: number;
}

export type CreateCustomLocationParameters = {
    address: string;
    lat?: number;
    lng?: number;
    placeId?: string;
}

export type LocationDetailsParameters = {
    name: string;
    placeId: string;
    lat: number;
    lng: number;
}

export type PlaceParameters = {
    placeId: string;
    hasPolygon?: boolean;
    sessionToken: google.maps.places.AutocompleteSessionToken;
    safegraphLocation?: ISafegraphLocation;
}

export type SetIsDrawingPolygonAction = IBaseAction<boolean>;
export type SetDrawPolygonAction = IBaseAction<PolygonType>;
export type SetSavedPolygonsAction = IBaseAction<IPolygon[]>;
export type SetInProcessPolygonAction = IBaseAction<IPolygon>;
export type SetLoadingMobilyticsReportAction = IBaseAction<boolean>;
export type SetSearchedPlaceMobilyticsAction = IBaseAction<SearchedPlaceInfo>;
export type SetIsCreatingCustomLocationAction = IBaseAction<boolean>;
export type SetIsViewingLocationDetailsAction = IBaseAction<boolean>;
export type OnCustomLocationSelectedAction = IBaseAction<PlaceParameters>;
export type OnLocationSelectedForAnalysisAction = IBaseAction<PlaceParameters>;
export type SetIsRedirectedFromCreateCustomLocation = IBaseAction<boolean>;
export type SetCreateCustomLocationParametersAction = IBaseAction<CreateCustomLocationParameters>;
export type SetLocationDetailsAction = IBaseAction<LocationDetailsParameters>;
export type SetIsSearchingForNewLocationAction = IBaseAction<boolean>;
export type RemoveSearchedPlaceMoblyitcsAction = IBaseAction<string>;
export type RemovePolygonAction = IBaseAction<string>;
export type SubmitMobilyticsReportInitiateAction = IBaseAction<ISubmitMobilyticsJobRequest>;
export type SubmitMobilyticsReportSuccessAction = IBaseAction<IGCPBigQueryJob[]>;
export type SubmitMobilyticsReportFailureAction = IBaseAction<string>;
export type SetMobilyticsScenariosAction = IBaseAction<IMobilyticsScenarioFormState[]>;
export type SetShouldShowEndOfReportScreenAction = IBaseAction<boolean>;
export type SetMostRecentlySubmittedMobilyticsReportAction = IBaseAction<IGCPBigQueryJob[]>;
export type GetNearbyLocationsAction = IBaseAction<ISafegraphLocation>;
export type GetSimilarLocationsAction = IBaseAction<ISafegraphLocation>;
export type SetNearbyLocationsAction = IBaseAction<ISafegraphLocation[]>;
export type SetSimilarLocationsAction = IBaseAction<ISafegraphLocation[]>;
export type SetSelectedSafegraphLocationAction = IBaseAction<ISafegraphLocation>;
export type StartMobilyticsFromSameMatchLocation = IBaseAction<IMobilyticsScenarioFormState>;
export type SetCustomReportTitle = IBaseAction<string>;
export type SetIsLoadingLocationsAction = IBaseAction<boolean>;

export type MobilyticsActionType =
    | SetIsDrawingPolygonAction
    | SetDrawPolygonAction
    | SetSavedPolygonsAction
    | SetInProcessPolygonAction
    | SetLoadingMobilyticsReportAction
    | SetIsCreatingCustomLocationAction
    | SetIsViewingLocationDetailsAction
    | OnCustomLocationSelectedAction
    | OnLocationSelectedForAnalysisAction
    | SetIsRedirectedFromCreateCustomLocation
    | SetCreateCustomLocationParametersAction
    | SetLocationDetailsAction
    | SetSearchedPlaceMobilyticsAction
    | RemoveSearchedPlaceMoblyitcsAction
    | RemovePolygonAction
    | SubmitMobilyticsReportInitiateAction
    | SubmitMobilyticsReportSuccessAction
    | SubmitMobilyticsReportFailureAction
    | SetMobilyticsScenariosAction
    | SetShouldShowEndOfReportScreenAction
    | SetMostRecentlySubmittedMobilyticsReportAction
    | SetIsSearchingForNewLocationAction
    | GetNearbyLocationsAction
    | GetSimilarLocationsAction
    | SetNearbyLocationsAction
    | SetSimilarLocationsAction
    | SetSelectedSafegraphLocationAction
    | StartMobilyticsFromSameMatchLocation
    | SetCustomReportTitle
    | SetIsLoadingLocationsAction;

export const SET_IS_DRAWING_POLYGON = "SET_IS_DRAWING_POLYGON";
export const SET_DRAW_POLYGON_TYPE = "SET_DRAW_POLYGON_TYPE";
export const SET_SAVED_POLYGONS = "SET_SAVED_POLYGONS";
export const SET_IN_PROCESS_POLYGON = "SET_IN_PROCESS_POLYGON";
export const SET_SEARCHED_PLACE_MOBILYTICS_ACTION = "SET_SEARCHED_PLACE_MOBILYTICS_ACTION";
export const REMOVE_SEARCHED_PLACE_MOBILYTICS_ACTION = "REMOVE_SEARCHED_PLACE_MOBILYTICS_ACTION";
export const REMOVE_POLYGON_ACTION = "REMOVE_POLYGON_ACTION";
export const SET_IS_CREATING_CUSTOM_LOCATION_ACTION = "SET_IS_CREATING_CUSTOM_LOCATION_ACTION";
export const SET_IS_VIEWING_LOCATION_DETAILS = "SET_IS_VIEWING_LOCATION_DETAILS";
export const ON_CUSTOM_LOCATION_SELECTED_ACTION = "ON_CUSTOM_LOCATION_SELECTED_ACTION";
export const ON_LOCATION_SELECTED_FOR_ANALYSIS_ACTION = "ON_LOCATION_SELECTED_FOR_ANALYSIS_ACTION";
export const SET_IS_REDIRECTED_FROM_CREATE_CUSTOM_LOCATION = "SET_IS_REDIRECTED_FROM_CREATE_CUSTOM_LOCATION";
export const SET_CREATE_CUSTOM_LOCATION_PARAMETERS_ACTION = "SET_CREATE_CUSTOM_LOCATION_PARAMETERS_ACTION";
export const SET_LOCATION_DETAILS_ACTION = "SET_LOCATION_DETAILS_ACTION";
export const GET_NEARBY_LOCATIONS_ACTION = "GET_NEARBY_LOCATIONS_ACTION";
export const GET_SIMILAR_LOCATIONS_ACTION = "GET_SIMILAR_LOCATIONS_ACTION";
export const SET_NEARBY_LOCATIONS_ACTION = "SET_NEARBY_LOCATIONS_ACTION";
export const SET_SIMILAR_LOCATIONS_ACTION = "SET_SIMILAR_LOCATIONS_ACTION";
export const SET_SELECTED_SAFEGRAPH_LOCATION_ACTION = "SET_SELECTED_SAFEGRAPH_LOCATION_ACTION";
export const SET_IS_SEARCHING_FOR_NEW_LOCATION_ACTION = "SET_IS_SEARCHING_FOR_NEW_LOCATION_ACTION";
export const SUBMIT_MOBILYTICS_REPORT_INITIATE = "SUBMIT_MOBILYTICS_REPORT_INITIATE";
export const SUBMIT_MOBILYTICS_REPORT_SUCCESS = "SUBMIT_MOBILYTICS_REPORT_SUCCESS";
export const SUBMIT_MOBILYTICS_REPORT_FAILURE = "SUBMIT_MOBILYTICS_REPORT_FAILURE";
export const SET_LOADING_MOBILYTICS_REPORT = "SET_LOADING_MOBILYTICS_REPORT";
export const SET_MOBILYTICS_SCENARIOS = "SET_MOBILYTICS_SCENARIOS";
export const SET_SHOULD_SHOW_END_OF_REPORT_SCREEN_ACTION = "SET_SHOULD_SHOW_END_OF_REPORT_SCREEN_ACTION";
export const SET_MOST_RECENTLY_SUBMITTED_MOBILYTICS_REPORT = "SET_MOST_RECENTLY_SUBMITTED_MOBILYTICS_REPORT";
export const START_MOBILYTICS_FROM_SAME_MATCH_LOCATION = "START_MOBILYTICS_FROM_SAME_MATCH_LOCATION";
export const SET_CUSTOM_REPORT_TITLE = "SET_CUSTOM_REPORT_TITLE";
export const SET_IS_LOADING_LOCATIONS = "SET_IS_LOADING_LOCATIONS";
